import Map, { Marker } from 'react-map-gl';

const MapComponent = () => {
  return (<>1</>
  );
};

export default MapComponent;

